import React from "react";

export default function Footer() {
  return (
        <footer className='footer-links'>
          <a href="https://twitter.com/Els_Luna87" target='_blank' rel='noreferrer'>
            <i className="fa fa-brands fa-twitter-square fa-2x social-icon"></i>
          </a>
          
          <a href="https://www.facebook.com/Lobo.Luna.87/" target='_blank' rel='noreferrer'>
            <i className="fa fa-brands fa-facebook-square fa-2x social-icon"></i>
          </a>

          <a href="https://www.instagram.com/elljudge/" target='_blank' rel='noreferrer'>
            <i className="fa fa-instagram fa-2x social-icon"></i>
          </a>

          <a href="https://github.com/EllieJ87" target='_blank' rel='noreferrer'>
            <i className="fa fa-brands fa-github-square fa-2x social-icon"></i>
          </a>
        </footer>
  );
}